import { render } from "./UserSelectionPopUpComponent.vue?vue&type=template&id=197b1ce5&scoped=true"
import script from "./UserSelectionPopUpComponent.vue?vue&type=script&lang=js"
export * from "./UserSelectionPopUpComponent.vue?vue&type=script&lang=js"

import "./UserSelectionPopUpComponent.vue?vue&type=style&index=0&id=197b1ce5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-197b1ce5"

export default script